<template lang="pug">
section
  s-page-title(:previous='true')
    template(slot='title')
      | Запись клиентов на осмотр <br> на {{ title }}
    template(slot='extension')
      div(:class=`{
        'no-wrap': true,
        'align-content-start flex mt-3': $vuetify.breakpoint.mdAndDown
      }`)
        v-btn(
          @click='onTodayClick'
          :disabled='!isRunning'
          v-if='$vuetify.breakpoint.lgAndUp'
          class='mt-0 mr-3'
          color='accent'
          small flat
        ) Сегодня
        v-btn(
          @click='prevPeriod'
          :disabled='!isRunning'
          :icon='$vuetify.breakpoint.smAndDown'
          color='default'
          class='mt-0 ml-0'
          depressed small
        )
          v-icon(:left='!$vuetify.breakpoint.smAndDown') chevron_left
          span(v-if='!$vuetify.breakpoint.smAndDown') Предыдущая неделя
        v-btn(
          @click='nextPeriod'
          :disabled='!isRunning'
          :icon='$vuetify.breakpoint.smAndDown'
          color='default'
          class='mt-0'
          depressed small
        )
          span(v-if='!$vuetify.breakpoint.smAndDown') Следующая неделя
          v-icon(:right='!$vuetify.breakpoint.smAndDown') chevron_right
        v-btn(
          @click='$cal.fireMethod("today")'
          :disabled='!isRunning'
          v-if='$vuetify.breakpoint.mdAndDown'
          class='mt-0'
          color='accent'
          small flat
        ) Сегодня
  v-container(grid-list-xl fluid class='pa-0')
    v-layout(wrap)
      v-flex(xs12 sm4)
        s-schedule-complex-picker(
          :return-object='true'
          v-model='complex'
          label='Выберите комплекс'
        )
      v-flex(xs12 sm8 v-if='complex.id')
        s-schedule-object-picker(
          :label='objectsFilterLabel'
          :filter='x => x.complex_id == complex.id'
          v-model='objects'
          multiple
        )
      v-flex(v-show='isRunning' xs12)
        v-card(class='calendar')
          full-calendar(
            @event-selected='onEventSelected'
            :config='config'
            ref='calendar'
          )
  assign-modal(
    @change='onSave'
    @destroyAssign='onDestroyAssign'
    :event='currEvent'
    :isLoading='isLoading'
    :duration='duration'
    :complex='complex'
    v-model='modals.event'
  )
</template>

<script>
import Vue from 'vue'

import { FullCalendar } from 'vue-full-calendar'
import 'fullcalendar/dist/fullcalendar.css'

import { pick } from 'lodash'
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'

import AssignSlot from './AssignSlot'
import AssignModal from './AssignModal'

import emitter from '@/emitter'

let events = []

export default {
  components: {
    FullCalendar,
    AssignModal
  },

  data: () => ({
    config: {
      locale: 'ru',
      height: 'auto',

      minTime: '07:00',
      maxTime: '21:00',

      slotDuration: '00:10:00',
      slotLabelFormat: 'HH:mm',
      columnHeaderFormat: 'ddd D MMM',

      header: false,
      selectable: false,
      allDaySlot: false,
      nowIndicator: true,
      eventDurationEditable: false,
      eventStartEditable: false,

      // TODO: сделать обновление слота
      eventRender(event, el) {
        events.push(
          new Vue({
            el: el.find('.fc-content').get(0),
            render(h) {
              return h(AssignSlot, {
                props: { event }
              })
            }
          })
        )
        emitter.$emit('schedule.assigns.create', event)
      }
    },
    modals: {
      event: false
    },
    view: {},
    objects: [],
    currEvent: {},
    duration: 30,
    isRunning: false,
    complex: {}
  }),

  mounted() {
    this.$cal.fireMethod('addEventSource', this.eventsSource)
    this.invalidateCalView()

    // TODO: необходимо для предотвращения
    // повторной подписки HMR
    if (this.unlisten) {
      this.unlisten()
    }

    this.unlisten = this.listen()
  },

  beforeDestroy() {
    this.unlisten()

    events.forEach(e => e.$destroy())
    events = []

    this.$cal.fireMethod('destroy')
  },

  methods: {
    listen() {
      emitter.$on('schedule.assigns', this.onScheduleUpdate)
      emitter.$on('schedule.assigns.create', this.onScheduleCreate)
      return () => {
        emitter.$off('schedule.assigns', this.onScheduleUpdate)
        emitter.$off('schedule.assigns.create', this.onScheduleCreate)
      }
    },

    prevPeriod() {
      this.$cal.fireMethod('prev')
      this.updateView()
    },

    nextPeriod() {
      this.$cal.fireMethod('next')
      this.updateView()
    },

    updateView() {
      this.view = { ...this.$cal.fireMethod('getView') }
    },

    refreshEvents() {
      this.$cal.fireMethod('refetchEvents')
    },

    invalidateCalView() {
      let view = 'agendaWeek'

      if (this.$vuetify.breakpoint.smAndDown) {
        view = 'agendaDay'
      }

      this.$cal.fireMethod('changeView', view)
      this.updateView()
    },

    /**
     * Возвращает только нужные поля для сохранения события
     * @param  {Object} event
     * @return {Object}
     */
    pickEvent(event) {
      return pick(event, [
        'allow',
        'complex_id',
        'end',
        'busy',
        'id',
        'objects',
        'start',
        'title',
        'assigns'
      ])
    },

    async onSave(event) {
      if (!this.isLoading) {
        try {
          await this.create({ data: event })
          this.modals.event = false
        } catch (e) {
          this.$showServerErrors(e)
        }
      }
    },

    async onDestroyAssign(assign) {
      if (
        !this.isLoading &&
        (await this.$confirm('Удалить запись на осмотр?'))
      ) {
        try {
          await this.destroy({ id: assign.id }).data

          let { assigns } = this.currEvent
          this.currEvent = Object.assign({}, this.currEvent, {
            assigns: assigns.filter(x => x.id !== assign.id)
          })
        } catch (e) {
          this.$showServerErrors(e)
        }
      }
    },

    onEventSelected(event) {
      this.currEvent = this.pickEvent(event)
      this.modals.event = true
    },

    onScheduleUpdate({ complex_id }) {
      if (complex_id === this.complex.id) {
        this.refreshEvents()
      }
    },

    onTodayClick() {
      this.$cal.fireMethod('today')
      this.updateView()
    },

    onScheduleCreate(event) {
      let { id } = this.currEvent
      if (id && id === event.id) {
        this.currEvent = this.pickEvent(event)
      }
    },

    ...mapMutations('app', ['incRequestsCount', 'decRequestsCount']),
    ...mapActions('schedule/schedule-assign', ['create', 'destroy'])
  },

  computed: {
    $cal() {
      return this.$refs.calendar
    },

    title() {
      return this.view.title
    },

    objectsFilterLabel() {
      let count = this.objects.length
      let { declofnum } = this.$options.filters
      let postfix = declofnum(count, ['объекту', 'объектам', 'объектам'])

      return this.objects.length
        ? `Включен фильтр по ${postfix}`
        : `Отображаются  все объекты кoмплекса`
    },

    eventsSource() {
      let vm = this
      return {
        cache: true,
        timeout: 20000,
        url: `${vm.$config.baseURL}/manager/schedule-assign`,

        data: () => ({
          objects: vm.objects,
          complex_id: vm.complex.id
        }),

        beforeSend(request) {
          request.setRequestHeader('Authorization', `Bearer ${vm.token}`)
          vm.incRequestsCount()
        },

        success({ state, data }) {
          vm.decRequestsCount()

          if (state) {
            return Object.values(data).map(e => ({
              ...e,
              textColor: '#313131',
              backgroundColor:
                e.busy >= e.allow
                  ? '#fce4ec'
                  : e.busy >= 1
                  ? '#ffe8ca'
                  : '#e8f5e9',
              objects: e.objects.map(o => o.object_id),
              allow: e.allow ? e.allow : 0,
              busy: e.busy ? e.busy : 0
            }))
          }
        },

        error() {
          vm.$root.showSnack('Ошибка загрузки расписания')
          vm.decRequestsCount()
        }
      }
    },

    ...mapState('auth', ['token']),
    ...mapGetters('schedule/schedule-assign', ['isLoading'])
  },

  watch: {
    'complex.id'(val) {
      if (val && !this.isRunning) {
        this.isRunning = true
        this.$nextTick(() => {
          this.$cal.fireMethod('render')
          this.invalidateCalView()
        })
      }

      this.objects = []
      this.refreshEvents()
    },
    /**
     * Отслеживает изменения вьюпорта
     * на мобильных устройствах включаем режи ДЕНЬ
     * в противном случае - неделя
     * @type {Object}
     */
    '$vuetify.breakpoint': 'invalidateCalView',

    objects: 'refreshEvents'
  }
}
</script>

<style scoped>
.cal-toolbar {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
}
.calendar >>> th,
.calendar >>> thead,
.calendar >>> .fc-widget-header {
  border-top: 0;
}
.calendar >>> .fc-widget-content,
.calendar >>> .fc-widget-header,
.calendar >>> .fc-sun {
  border-right: 0;
}
.calendar >>> .fc-widget-header:first-child {
  border-left: 0;
}
.calendar >>> .fc-axis.fc-time,
.calendar >>> .fc-body > tr > .fc-widget-content {
  border-left: 0;
}
.calendar >>> .fc-widget-content {
  border-bottom: 0;
}
.calendar >>> .fc-axis.fc-time {
  font-size: 10px;
}
.calendar >>> .fc-widget-header span {
  padding: 12px 0;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
}
.calendar >>> .fc-event {
  padding: 3px;
  margin-top: 1px;
  border-radius: 0;
  border-color: white;
  color: #000 !important;
}
.calendar >>> .fc-today {
  background: none;
}
.calendar >>> .fc-day-header.fc-today {
  color: #eb8d8d;
}
.calendar >>> .fc-day-header span:first-letter {
  text-transform: uppercase;
}
.calendar >>> .fc-now-indicator {
  border-color: #eb8d8d;
}
.calendar >>> .fc-now-indicator-arrow {
  border: 0;
  width: 7px;
  height: 7px;
  left: 31px;
  margin-top: -3px;
  background: #eb8d8d;
  border-radius: 50%;
}
</style>
